import { useMemo } from "react";
import { useI18n } from "../hooks";

interface ExpirationDateApprovedProps {
	expirationDate: string;
}

const ExpirationDateApproved: React.FC<ExpirationDateApprovedProps> = ({ expirationDate }) => {
	const validUntil = useI18n(i => i.am.validUntil);

	const expirationDateForamtted = useMemo(() => {
		if (!expirationDate) return;

		const theDate = new Date(expirationDate);
		const month = theDate.getMonth();
		const year = theDate.getFullYear();

		return `${month + 1}/${year}`
	}, [expirationDate]);

	return expirationDate ? <span className='expiry'>{validUntil}{expirationDateForamtted}</span> : null;
}

export default ExpirationDateApproved;